// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"c79ccb9b","49":"c21687ab","154":"11e1c35e","235":"7310cdbc","860":"19b69ebb","914":"d68eb1c7"}[chunkId] + ".css";
};